import { Content as TabsContent } from "@radix-ui/react-tabs";
import type { TabsContentProps as RadixTabsContentProps } from "@radix-ui/react-tabs";
import { cn } from "@/lib/utils";

export type TabPanelProps = React.ComponentProps<"div"> & RadixTabsContentProps;

const TabPanel: React.FC<TabPanelProps> = ({ value, children, className }) => {
  return (
    <TabsContent
      value={value}
      className={cn(
        'absolute top-0 left-0 w-full pointer-events-none data-[state="inactive"]:animate-fade-out-down data-[state="inactive"]:z-10 data-[state="active"]:animate-fade-in-up data-[state="active"]:z-20 data-[state="active"]:relative data-[state="active"]:pointer-events-auto',
        className
      )}
      forceMount
    >
      {children}
    </TabsContent>
  );
};

export default TabPanel;
